import { render, staticRenderFns } from "./Ambition.vue?vue&type=template&id=7d484f8e&scoped=true"
import script from "./Ambition.vue?vue&type=script&lang=js"
export * from "./Ambition.vue?vue&type=script&lang=js"
import style0 from "./Ambition.vue?vue&type=style&index=0&id=7d484f8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d484f8e",
  null
  
)

export default component.exports